import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    Grid,
    Card,
    CardContent,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box,
    Tabs,
    Tab,
} from "@mui/material";

import Schneider from "./forms/Schneider";
import Sultantur from "./forms/Sultantur";
import DashboardNavbar from "../../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../../examples/Footer";
import DashboardLayout from "../../../../../examples/LayoutContainers/DashboardLayout";
import CrudService from "services/cruds-service";
import MDTypography from "../../../../../components/MDTypography";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";

const CreateSpotQuotingTool = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const spotQuotingToolId = searchParams.get("id");

    const [selectedMode, setSelectedMode] = useState("Road");
    const [selectedCarrier, setSelectedCarrier] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    // An existing spot quote opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(Boolean(spotQuotingToolId));

    useEffect(() => {
        if (spotQuotingToolId) {
            setIsEditing(true);
            fetchSpotQuotingToolDetails(spotQuotingToolId);
        }
        setReadOnlyMode(Boolean(spotQuotingToolId));
    }, [spotQuotingToolId]);

    const fetchSpotQuotingToolDetails = async (id) => {
        try {
            const response = await CrudService.getSpotQuotingToolById(id);
            const spotQuotingToolData = response.data.attributes;

            setSelectedCarrier(spotQuotingToolData.selectedCarrier);

            if (["Schneider", "Sultantur"].includes(spotQuotingToolData.selectedCarrier)) {
                setSelectedMode("Road");
            }
        } catch (error) {
            console.error("Error fetching quoting tool details:", error);
        }
    };

    const handleModeChange = (event, newValue) => {
        setSelectedMode(newValue);
        setSelectedCarrier("");
    };

    return (
        <DashboardLayout>
            <Box sx={{ m: 0, p: 0 }}>
                <DashboardNavbar />

                <Grid container spacing={2} sx={{ m: 0, p: 0 }}>
                    {!isEditing && (
                        <Grid container justifyContent="center">
                            <Grid item xs={12} sm={4} sx={{ m: 0, p: 0 }}>
                                <Box
                                    sx={{
                                        height: "10vh",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
                                        Create Spot Quote
                                    </Typography>

                                    <MDTypography variant="h6" color="secondary">
                                        Select transport mode and fill in the required details
                                    </MDTypography>
                                </Box>

                                <Card elevation={2} sx={{ borderRadius: "8px", width: "100%", p: 1 }}>
                                    <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                                        <Tabs
                                            value={selectedMode}
                                            onChange={handleModeChange}
                                            variant="fullWidth"
                                            sx={{ mb: 2 }}
                                        >
                                            <Tab label="Road" value="Road" />
                                            <Tab label="Ocean" value="Ocean" />
                                            <Tab label="Air" value="Air" />
                                        </Tabs>

                                        {selectedMode === "Road" && (
                                            <FormControl fullWidth variant="standard">
                                                <InputLabel id="carrier-label" sx={{ fontSize: "14px" }}>
                                                    Select Carrier
                                                </InputLabel>

                                                <Select
                                                    labelId="carrier-label"
                                                    value={selectedCarrier}
                                                    onChange={(e) => setSelectedCarrier(e.target.value)}
                                                    sx={{ height: 40, fontSize: "14px" }}
                                                >
                                                    <MenuItem value="Schneider">🚛 Schneider</MenuItem>
                                                    <MenuItem value="Sultantur">🚚 Sultantur</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}

                                        {selectedMode === "Ocean" && (
                                            <Typography variant="body2" color="text.secondary">
                                                Ocean spote quote form will be added here.
                                            </Typography>
                                        )}

                                        {selectedMode === "Air" && (
                                            <Typography variant="body2" color="text.secondary">
                                                Air spote quote form will be added here.
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    )}

                    <Grid item xs={12} sx={{ m: 0, p: 0, width: "100%", flexGrow: 1 }}>
                        {readOnlyMode && (
                            <Box sx={{ px: 2, pt: 2 }}>
                                <ReadOnlyBanner
                                    message="This spot quote is in read-only view. Click Edit to make changes."
                                    onEdit={() => setReadOnlyMode(false)}
                                    mb={0}
                                />
                            </Box>
                        )}
                        <ReadOnlyFieldset readOnly={readOnlyMode}>
                            {selectedMode === "Road" && selectedCarrier === "Schneider" && (
                                <Schneider selectedCarrier={selectedCarrier} />
                            )}

                            {selectedMode === "Road" && selectedCarrier === "Sultantur" && (
                                <Sultantur selectedCarrier={selectedCarrier} />
                            )}
                        </ReadOnlyFieldset>
                    </Grid>
                </Grid>

                <Box sx={{ mt: selectedCarrier ? 0 : 75 }}>
                    <Footer />
                </Box>
            </Box>
        </DashboardLayout>
    );
};

export default CreateSpotQuotingTool;